/**
 * Created by karel on 13/05/16.
 */
var lib_core     = require("lib-core");
var ui_templates = require("ui-templates");
var $            = require("jquery");
var _            = require("underscore");

var LoadingView = function(editorHolder, options){
    var self = this;
    
    this.editorHolder = editorHolder;
    this.icon = options.icon;
    this.title = options.title;
    this.description = options.description;
    this.showOnlyLoadingBar = options.showOnlyLoadingBar;

    this.getTemplate();
};

LoadingView.prototype.getTemplate = function(){
    var self = this;

    if(!this._template){
        this._template = new ui_templates.Splashscreen({
            target: $(this.editorHolder), 
            fields: {
                "icon": self.icon,
                "title": self.title,
                "description": self.description,
                "showOnlyLoadingBar": self.showOnlyLoadingBar
            }
        });
    }
    return this._template;
};

LoadingView.prototype.hide = function(){
    this.getTemplate().hide();
};


module.exports = LoadingView;
